export function serializeForm(formElement) {
  const formData = new FormData(formElement);
  const formObject = {};

  formData.forEach((value, key) => {
    // Find the form element for this key
    const element = formElement.querySelector(`[name="${key}"]`);

    if (element && !element.required) {
      // Skip non-required select fields that are hidden or have default first option selected
      if (element.tagName.toLowerCase() === "select") {
        const isHidden = element.closest(".hidden") !== null;
        if (isHidden) {
          return; // Skip this field
        }
      }

      // Skip non-required radio fields with no checked option
      if (element.type === "radio") {
        const radioGroup = formElement.querySelectorAll(`input[name="${key}"]`);
        const hasChecked = Array.from(radioGroup).some(
          (radio) => radio.checked
        );
        if (!hasChecked) {
          return; // Skip this field
        }
      }
    }

    const keys = key.split("[").map((k) => k.replace("]", ""));
    keys.reduce((acc, cur, i) => {
      if (i === keys.length - 1) {
        acc[cur] = value;
      } else {
        acc[cur] = acc[cur] || (isNaN(keys[i + 1]) ? {} : []);
      }
      return acc[cur];
    }, formObject);
  });

  return formObject;
}

export function capitalize(str) {
  if (typeof str !== "string" || str.length === 0) {
    return str;
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function escapeHtml(value) {
  const div = document.createElement("div");
  div.textContent = String(value);
  return div.innerHTML;
}

export function distanceMetersBetween(first, second) {
  if (!first || !second) return null;
  const toRadians = (degrees) => (degrees * Math.PI) / 180;
  const earthRadiusM = 6371000;
  const firstLat = toRadians(Number(first.lat));
  const secondLat = toRadians(Number(second.lat));
  const deltaLat = toRadians(Number(second.lat) - Number(first.lat));
  const deltaLon = toRadians(Number(second.lon) - Number(first.lon));

  if (
    !Number.isFinite(firstLat) ||
    !Number.isFinite(secondLat) ||
    !Number.isFinite(deltaLat) ||
    !Number.isFinite(deltaLon)
  ) {
    return null;
  }

  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(firstLat) *
      Math.cos(secondLat) *
      Math.sin(deltaLon / 2) *
      Math.sin(deltaLon / 2);
  return 2 * earthRadiusM * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function getFarmIdFromUrl(url) {
  const regex = /\/?farms\/(\d+)(?:\/|$|\?|#)/;
  const match = url.match(regex);
  if (match) {
    const farmId = match[1];

    return Number(farmId);
  } else {
    return null;
  }
}
